window.onbeforeunload = function () {
  const header = document.querySelector("header");
  const main = document.querySelector("main");
  const footer = document.querySelector("footer");

  // Initially all will be displayed none
  header.style.display = "none";
  main.style.display = "none";
  footer.style.display = "none";

  window.scrollTo(0, 0);
};

function lenisSmoothScroll() {
  const lenis = new Lenis();

  lenis.on("scroll", ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);
}
lenisSmoothScroll();

function preloader_animation() {
  var counterElement = document.querySelector(".preloader__counter");
  var currentValue = 0;

  function updateCounter() {
    if (currentValue === 100) {
      return;
    }

    currentValue += Math.floor(Math.random() * 10) + 1;

    if (currentValue > 100) {
      currentValue = 100;
    }

    counterElement.textContent = currentValue;

    var delay = Math.floor(Math.random() * 200) + 50;
    setTimeout(updateCounter, delay);
  }
  updateCounter();
}
preloader_animation();

function cursor_animation() {
  const cursor = document.querySelector("#cursor");
  const imgContainers = document.querySelectorAll(".project__image-container");

  window.addEventListener("mousemove", (e) => {
    gsap.to(cursor, {
      x: e.clientX,
      y: e.clientY,
      width: 20,
      height: 20,
      duration: 0.4,
      ease: "power2.out",
    });
  });

  document.addEventListener("mouseout", (event) => {
    if (!event.relatedTarget || event.relatedTarget.nodeName === "HTML") {
      gsap.to(cursor, {
        width: 0,
        height: 0,
        duration: 0.5,
        ease: "power2.out",
      });
    }
  });

  imgContainers.forEach((imgContainer) => {
    imgContainer.addEventListener("mouseover", () => {
      cursor.innerHTML = "View Project";
      cursor.style.color = "#fff";
      cursor.style.fontSize = "4.5px";
      cursor.style.padding = "2px";

      gsap.to(cursor, {
        scale: 3,
        duration: 0.2,
        ease: "power2.out",
      });
    });

    imgContainer.addEventListener("mouseout", () => {
      cursor.innerHTML = "";
      cursor.style.color = "";
      cursor.style.fontSize = "";
      cursor.style.padding = "";
      gsap.to(cursor, {
        scale: 1,
        duration: 0.2,
        ease: "power2.out",
      });
    });
  });
}
cursor_animation();

function hero_animation() {
  var tl = gsap.timeline();

  tl.to("body", {
    overflow: "hidden",
  });
  tl.to(".preloader", {
    duration: 2.7,
  });
  tl.to(".preloader", {
    duration: 1.2,
    height: "0vh",
    ease: "Power3.easeOut",
  });
  tl.to(
    "body",
    {
      overflow: "auto",
    },
    "-=1.5"
  );
  tl.from(".hero__title, .hero__description", {
    y: 50,
    stagger: 0.1,
    duration: 0.5,
    opacity: 0,
  });
  tl.from(".hero__designation", {
    y: 180,
  });
}
hero_animation();

function skills_animation() {
  var tl = gsap.timeline({
    scrollTrigger: {
      trigger: "#skills",
      start: "0% 20%",
      end: "0% 20%",
    },
  });

  tl.from(".skills__image, .skills__title", {
    opacity: 0,
    x: -50,
    stagger: 0.1,
    duration: 1.2,
    opacity: 0,
  });
}
skills_animation();

function project_animation() {
  var tl1 = gsap.timeline({
    scrollTrigger: {
      trigger: "#second_project",
      start: "10% 40%",
      end: "10% 40%",
      scrub: 1,
      duration: 0.5,
    },
  });

  tl1.to("#projects", {
    backgroundColor: "#071421",
    color: "#e7e7e7",
  });

  tl1.to(".project__tech span", {
    borderColor: "#e7e7e7",
  });

  var tl2 = gsap.timeline({
    scrollTrigger: {
      trigger: "#third_project",
      start: "5% 40%",
      end: "5% 40%",
      scrub: 1,
      duration: 0.5,
    },
  });

  tl2.to("#projects", {
    backgroundColor: "#80c4e9",
    color: "#e7e7e7",
    color: "#000",
  });

  tl2.to(".project__tech span", {
    borderColor: "#e7e7e7",
    borderColor: "#000",
  });

  var tl3 = gsap.timeline({
    scrollTrigger: {
      trigger: "#fourth_project",
      start: "10% 40%",
      end: "10% 40%",
      scrub: 1,
      duration: 0.5,
    },
  });

  tl3.to("#projects", {
    backgroundColor: "#758694",
    color: "#fff",
  });

  tl3.to(".project__tech span", {
    borderColor: "#fff",
  });
}

project_animation();

function footer_button_animation() {
  const btn = document.querySelector(".footer__contact-button");
  const lerp = (a, b, t) => a + (b - a) * t;

  btn.addEventListener("mousemove", (ev) => {
    const dimens = btn.getBoundingClientRect();
    const xStart = dimens.x;
    const xEnd = xStart + dimens.width;

    const yStart = dimens.y;
    const yEnd = yStart + dimens.height;

    const xValue = gsap.utils.mapRange(xStart, xEnd, 0, 1, ev.clientX);
    const yValue = gsap.utils.mapRange(yStart, yEnd, 0, 1, ev.clientY);

    gsap.to(btn, {
      transform: `translate(${lerp(-30, 30, xValue)}px, ${lerp(
        -30,
        30,
        yValue
      )}px)`,
    });
  });
  btn.addEventListener("mouseleave", (ev) => {
    gsap.to(btn, {
      transform: `translate(0px)`,
    });
  });

  btn.addEventListener("click", () => {
    const emailAddress = "pranayshah2206@gmail.com";
    navigator.clipboard // Navigator API
      .writeText(emailAddress)
      .then(function () {
        btn.innerHTML = "Copied!";
        setTimeout(() => {
          btn.innerHTML = "Copy Email";
        }, 5000);
      })
      .catch(function (error) {
        console.error("Error copying text: ", error);
      });
  });
}
footer_button_animation();

function updateTime() {
  const timeElement = document.getElementById("footer__location-time");
  const now = new Date();
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  };
  timeElement.textContent = now.toLocaleTimeString("en-US", options);
}
updateTime();
setInterval(updateTime, 1000);

function backToTop() {
  const footer_Btn = document.getElementById("footer__btn");
  footer_Btn.addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
}
backToTop();
